<div class="voting-page">
  <div class="voting-shell voting-shell--loading" [class.is-loading]="isLoading"
    [class.is-visible]="isLoading && showLoadingSkeleton"
    [attr.aria-hidden]="isLoading && showLoadingSkeleton ? null : 'true'">
    <section class="hero-skeleton" aria-label="Carregando apresentação da votação">
      <div class="hero-skeleton-copy">
        <ejs-skeleton shape="Text" width="360px" height="16px"></ejs-skeleton>
        <ejs-skeleton shape="Rectangle" width="90%" height="44px"></ejs-skeleton>
        <ejs-skeleton shape="Rectangle" width="62%" height="44px"></ejs-skeleton>

        <div class="skeleton-lines">
          <ejs-skeleton shape="Text" width="94%" height="18px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="80%" height="18px"></ejs-skeleton>
        </div>

        <div class="hero-skeleton-badges">
          <ejs-skeleton shape="Rectangle" width="222px" height="38px"></ejs-skeleton>
          <ejs-skeleton shape="Rectangle" width="188px" height="38px"></ejs-skeleton>
          <ejs-skeleton shape="Rectangle" width="208px" height="38px"></ejs-skeleton>
        </div>
      </div>

      <aside class="hero-skeleton-summary">
        <ejs-skeleton shape="Text" width="180px" height="15px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="68%" height="36px"></ejs-skeleton>
        <ejs-skeleton shape="Text" width="60%" height="16px"></ejs-skeleton>

        <div class="skeleton-lines">
          <ejs-skeleton shape="Text" width="100%" height="15px"></ejs-skeleton>
          <ejs-skeleton shape="Text" width="84%" height="15px"></ejs-skeleton>
        </div>
      </aside>
    </section>

    <app-voting-steps
      [isLoading]="isLoading"
      [showLoadingSkeleton]="showLoadingSkeleton"
      (resetRequested)="handleResetRequested()">
    </app-voting-steps>
  </div>

  <app-voting-no-active-election
    *ngIf="shouldShowNoActiveElection"
    (activeElectionDetected)="handleActiveElectionDetected()">
  </app-voting-no-active-election>

  <div class="voting-shell" *ngIf="!isLoading && shouldShowVotingShell && votingData as data">
    <section class="voting-hero" aria-label="Apresentação da votação da CIPA">
      <ngx-particles *ngIf="showParticles" class="hero-particles" [id]="particlesId" [options]="particlesOptions"
        [particlesInit]="particlesInit" (particlesLoaded)="particlesLoaded($event)"></ngx-particles>

      <div class="hero-copy">
        <span class="hero-kicker">{{ data.election.companyName }} • {{ data.election.establishmentName }}</span>
        <h1 class="hero-title">{{ data.introductionTitle }}</h1>
        <p class="hero-description">{{ data.introductionText }}</p>

        <div class="hero-badges">
          <span class="hero-badge">
            <i class="fa fa-calendar-alt" aria-hidden="true"></i>
            Encerramento em {{ data.election.votingEndAt | date:'dd/MM/yyyy' }}
          </span>
          <span class="hero-badge">
            <i class="fa fa-id-badge" aria-hidden="true"></i>
            {{ data.voter.role }} • {{ data.voter.department }}
          </span>
          <span class="hero-badge">
            <i class="fa fa-users" aria-hidden="true"></i>
            {{ data.election.eligibleCandidatesCount }} candidatos • até {{ maxVotesPerVoter }} escolhas
          </span>
        </div>
      </div>

      <aside class="hero-summary" aria-label="Resumo do participante e da votação">
        <span class="summary-label">Sua identificação nesta votação</span>
        <strong class="summary-name">{{ data.voter.name }}</strong>
        <span class="summary-role">{{ data.voter.role }} • {{ data.voter.department }}</span>
        <p class="summary-text">{{ data.companyMessage }}</p>
      </aside>
    </section>

    <app-voting-live-tracker *ngIf="shouldShowLiveTracking; else votingSteps"
      [votingData]="data" [trackingData]="data.liveTracking!"></app-voting-live-tracker>

    <ng-template #votingSteps>
      <app-voting-steps
        [votingData]="data"
        (resetRequested)="handleResetRequested()">
      </app-voting-steps>
    </ng-template>
  </div>
</div>
